import _ from 'lodash';
import {
  useCallback,
  useMemo
} from 'react';

import {
  StoreTypeName,
  useStoreListWidgetQuery,
  useTestStoreConnectionLazyQuery
} from 'generated/graphql';



export interface IStore {
  id: string;
  name: string;
  websiteUrl: string;
  orderPrefix: string;
  logoUrl: string;

  primaryColorHex: string;
  secondaryColorHex: string;
  buttonColorHex: string;
  type: StoreTypeName;
}

export interface IData {
  stores: IStore[];
}

export function useQuery() {
  const tuple = useStoreListWidgetQuery({
    fetchPolicy: 'network-only',
    variables: {}
  });

  return useMemo(
    () => {
      const stores = _.map(tuple.data?.stores.nodes ?? [], (store): IStore => {
        let websiteUrl = '';
        if (store.metaData?.__typename === 'ShopifyStoreMetaData' || store.metaData?.__typename === 'WooCommerceStoreMetaData' || store.metaData?.__typename === 'SftpStoreMetaData') {
          websiteUrl = store.metaData.baseUrl;
        } else if (store.metaData?.__typename === 'Telgoo5StoreMetaData') {
          websiteUrl = store.metaData.apiUrl;
        }

        return {
          id: store.id,
          orderPrefix: store.orderPrefix,
          logoUrl: store.logoUrl,
          name: store.name,
          websiteUrl,
          primaryColorHex: store.primaryColorHex,
          secondaryColorHex: store.secondaryColorHex,
          buttonColorHex: store.buttonColorHex,
          type: store.type.name
        };
      });

      const data: IData = {
        stores: _.sortBy(stores, store => _.toLower(store.name))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useTestStoreConnection() {
  const [fnQuery, tuple] = useTestStoreConnectionLazyQuery({ fetchPolicy: 'network-only' });

  const fnWrappedQuery = useCallback(
    (storeId: string) => {
      return fnQuery({
        variables: { storeId }
      });
    },
    [fnQuery]
  );

  return useMemo(
    () => [
      fnWrappedQuery,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedQuery,
      tuple
    ]);
}
